import React from 'react';
import { X } from 'lucide-react';
import styles from './ui-chip.module.scss';

interface UIChipProps {
    active?: boolean;
    primary?: boolean;
    onClose?: () => void;
    onClick?: () => void;
    children: React.ReactNode;
    className?: string;
}

export function UIChip({
    active = false,
    primary = false,
    onClose,
    onClick,
    children,
    className = '',
}: UIChipProps) {
    const classes = [
        styles.chip,
        active ? styles.active : '',
        primary ? styles.primary : '',
        onClick ? styles.clickable : '',
        className,
    ].filter(Boolean).join(' ');

    return (
        <span className={classes} onClick={onClick}>
            <span className={styles.label}>{children}</span>
            {onClose && (
                <button
                    type="button"
                    className={styles.close}
                    onClick={(e) => {
                        e.stopPropagation();
                        onClose();
                    }}
                >
                    <X size={12} />
                </button>
            )}
        </span>
    );
}

export default UIChip;
